export const landingShapes = [
  {
    top: "25%",
    width: "80px",
    delay: "0s",
  },
  {
    top: "10%",
    width: "20px",
    delay: "2s",
    duration: "12s",
  },
  {
    top: "70%",
    width: "20px",
    delay: "4s",
  },
  {
    top: "40%",
    width: "60px",
    delay: "0s",
    duration: "18s",
  },
  {
    top: "65%",
    width: "20px",
    delay: "0s",
  },
  {
    top: "75%",
    width: "110px",
    delay: "3s",
  },
  {
    top: "35%",
    width: "150px",
    delay: "7s",
  },
  {
    top: "50%",
    width: "25px",
    delay: "15s",
    duration: "45s",
  },
  {
    top: "20%",
    width: "15px",
    delay: "2s",
    duration: "35s",
  },
  {
    top: "85%",
    width: "60px",
    delay: "0s",
    duration: "11s",
  },
];
